import script from "./Howitworkssection.vue?vue&type=script&setup=true&lang=js"
export * from "./Howitworkssection.vue?vue&type=script&setup=true&lang=js"

import "./Howitworkssection.vue?vue&type=style&index=0&id=6c66a923&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c66a923"]])

export default __exports__